module.exports = __webpack_public_path__ + "static/media/scottish_bs.7bdfb7f3.jfif";